import React, { useState } from 'react';
import { FiGlobe, FiLock } from 'react-icons/fi';

import { ColorPalette } from 'theme/colors';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useUserAccount from 'hooks/useUserAccount';
import TravelerLoyaltyContainer from 'screens/containers/TravelerLoyalty';

import ChangePasswordForm from './components/ChangePassword';
import LanguageSelector from './components/LanguageSelector';
import { MenuItem, Icon, ItemTitle, IconEdit, IconContainer } from './styles';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

type Props = {
  setLoading: (loading: boolean) => void;
};

const Preferences = ({ setLoading }: Props) => {
  const { t } = useStoreTranslation();
  const [showLoyalty, setShowLoyalty] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const user = useUserAccount();
  const history = useHistory();
  const handleCloseLoyalty = () => setShowLoyalty(false);
  const handleCloseChangePassword = () => setShowChangePassword(false);
  const companyConfiguration = useSelector((state: RootState) => state.companyConfiguration.configuration);

  return (
    <>
      {(user.creditCardByUser || user.hasCreditCardByUserException) &&
       <MenuItem onClick={() => history.push('/corporate/paymentMethods')}>
       <IconContainer>
         <Icon src="/corporate/images/payment/payment-card-default.svg" />
       </IconContainer>
       <ItemTitle>{t('preferences.options.creditCards')}</ItemTitle>
       <IconEdit src="/corporate/images/edit-arrow-right.svg" />
     </MenuItem>
      }
      <MenuItem onClick={() => setShowLoyalty(true)}>
        <IconContainer>
          <Icon src="/corporate/images/traveler-profile/ribbon.svg" />
        </IconContainer>
        <ItemTitle>{t('preferences.options.loyalty')}</ItemTitle>
        <IconEdit src="/corporate/images/edit-arrow-right.svg" />
      </MenuItem>

      <MenuItem onClick={() => setShowLanguage(true)}>
        <IconContainer>
          <FiGlobe color={ColorPalette.HEX.PineTree} />
        </IconContainer>
        <ItemTitle>{t('preferences.options.language')}</ItemTitle>
        <IconEdit src="/corporate/images/edit-arrow-right.svg" />
      </MenuItem>

      {!(companyConfiguration?.loginSso?.sso?.length > 0) && (
        <MenuItem onClick={() => setShowChangePassword(true)}>
          <IconContainer>
            <FiLock color={ColorPalette.HEX.PineTree} />
          </IconContainer>
          <ItemTitle>{t('preferences.options.changePassword')}</ItemTitle>
          <IconEdit src="/corporate/images/edit-arrow-right.svg" />
        </MenuItem>
      )}
      
      <ApplicationOverlayContent sidebar show={showLoyalty} onClose={handleCloseLoyalty}>
        <TravelerLoyaltyContainer onClose={handleCloseLoyalty} userId={user.id} />
      </ApplicationOverlayContent>

      <LanguageSelector show={showLanguage} setShow={setShowLanguage} setLoading={setLoading} />

      <ChangePasswordForm onClose={handleCloseChangePassword} show={showChangePassword} />
    </>
  );
};

export default Preferences;
